import React, { useState } from "react";
import Slider from "react-slick";
import { motion } from "framer-motion"; // Importation de framer-motion
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./style.css";
import { Button } from "@mui/material";
import ScrollToTop from '../../Components/scrollup'

const settings = {
  focusOnSelect: true,
  pauseOnHover: false,
  infinite: true,
  speed: 400,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 4000,
  fade: false,
  arrows: false,
  dots: false,
};

function Home() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const handleAfterChange = (index) => {
    setCurrentSlide(index);
  };

  return (
    <div className="home">
      <ScrollToTop/>
      <div className="carouselHome">
        <Slider {...settings} afterChange={handleAfterChange}>
          {slides.map((slide, index) => (
            <div key={index} className="slide-item">
              <img
                src={require(`../../images/${slide.img}.jpg`)}
                alt={`Slide ${index + 1}`}
              />
              <div
                className="slideText"
                style={{
                  backgroundImage: `url(${require(`../../images/${slide.img}.jpg`)})`,
                }}
              >
                <motion.div>
                  <motion.p
                    className="p1"
                    initial={{ opacity: 0, y: 50 }}
                    animate={{
                      opacity: currentSlide === index ? 1 : 0,
                      y: currentSlide === index ? 0 : 50,
                    }}
                    transition={{
                      duration: 0.3,
                      ease: "easeOut",
                    }}
                  >
                    {slide.descreption}
                  </motion.p>
                  <motion.p
                    className="p2"
                    initial={{ opacity: 0, y: 70 }}
                    animate={{
                      opacity: currentSlide === index ? 1 : 0,
                      y: currentSlide === index ? 0 : 40,
                    }}
                    transition={{
                      duration: 0.3,
                      ease: "easeOut",
                      delay: 0.3,
                    }}
                  >
                    {slide.descreption2}
                  </motion.p>
                  <motion.div
                    className="p2"
                    initial={{ opacity: 0, y: 70 }}
                    animate={{
                      opacity: currentSlide === index ? 1 : 0,
                      y: currentSlide === index ? 0 : 40,
                    }}
                    transition={{
                      duration: 0.4,
                      ease: "easeOut",
                      delay: 0.8,
                    }}
                  >
                    <a href={slide.buttonLink}>
                      <Button
                        sx={{ cursor: "pointer" }}
                        variant="contained"
                        color="warning"
                        size="large"
                      >
                        {slide.button}
                      </Button>
                    </a>
                  </motion.div>
                </motion.div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}

export default Home;

const slides = [
  {
    img: "home1",
    descreption: "Solutions Digitales Complètes",
    descreption2: "Transformons vos idées en réalité !",
    button: "demander un devis",
    buttonLink: "mailto:hossjanfaoui.dev@gmail.com",
  },
  {
    img: "home2",
    descreption: "Création de sites modernes",
    descreption2: "Expert en nouvelles technologies",
    button: "nos projets",
    buttonLink: "projets",
  },
  {
    img: "home3",
    descreption: "booster votre visibilité en ligne",
    descreption2: "Découvrez nos articles sur les différents sujets du digital",
    button: "blog",
    buttonLink: "blog",
  },
];
